import React from "react";
import styled from "styled-components";
import { Map } from "immutable";
import { connect } from "react-redux";
import { i18n } from "../../services";
import { isMobile, mysqlDateToArabic } from "../../helpers";
import { fetchPages, setPagePositions } from "../../reducers/pages/actions";
import { AppState } from "../../store";
import Actions from "./Actions";
import { Table, RowProps, RowPositions } from "../../lib/ui/Table";

export const Container = styled.div``;

const mapState = ({ pages, settings }: AppState, { doc_id }: OwnProps) => ({
    // @ts-ignore
    docLastOpened: settings.get("docLastOpened") as Map<number, number>,
    pages: Map<string, any>(
        // @ts-ignore
        pages.filter((p: any) => p.get("doc_id") === doc_id)
    ),
});
const mapDispatch = {
    fetchPages,
    setPagePositions,
};
type StateProps = ReturnType<typeof mapState>;
type DispatchProps = typeof mapDispatch;
type OwnProps = {
    doc_id: number;
};
type Props = StateProps & DispatchProps & OwnProps;
type State = {
    selected: number[];
};

class List extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            selected: [],
        };
    }

    async componentDidMount() {
        const { doc_id } = this.props;
        this.props.fetchPages({ doc_id });
    }

    onRowClick = (row: RowProps) => {
        const doc_id = row.id as number;
        let { selected } = this.state;

        if (selected.includes(doc_id)) {
            selected.splice(selected.indexOf(doc_id), 1);
        } else {
            selected.push(doc_id);
        }

        this.setState({ selected: selected.slice() });
    };

    isSelected = (row: RowProps) =>
        this.state.selected.includes(row.id as number);

    onDragEnd = (positions: RowPositions) => {
        const { doc_id } = this.props;
        this.props.setPagePositions({
            doc_id,
            positions: positions.map((p) => p),
        });
    };

    table() {
        const { pages } = this.props;
        let fields = ["name", "status", "updated_at"];
        let titles = ["pageForm.name", "pageForm.status", "form.date"];

        if (isMobile()) {
            fields = ["name", "status"];
            titles = ["pageForm.name", "pageForm.status"];
        }

        const transform = {
            updated_at: mysqlDateToArabic,
            visibility: (visibility: string) =>
                i18n.get(`docForm.visibility${visibility}`),
            status: (status: string) => i18n.get(`docForm.status${status}`),
        };

        const width = ["70%", "15%", "15%"];
        const rows = pages.toList().toJS();

        return (
            <Table
                width={width}
                titles={titles}
                fields={fields}
                transform={transform}
                //@ts-ignore
                rows={rows}
                indent={true}
                isSelected={this.isSelected}
                onRowClick={this.onRowClick}
                rowId="id"
                draggable={true}
                onDragEnd={this.onDragEnd}
            />
        );
    }

    clearSelected = () => this.setState({ selected: [] });

    render() {
        const { pages, doc_id, docLastOpened } = this.props;
        if (pages.size === 0) {
            return null;
        }

        let lastOpened = pages.min((p) => p.position).get("id");
        if (docLastOpened.has(doc_id)) {
            lastOpened = docLastOpened.get(doc_id);
        }

        return (
            <Container>
                <Actions
                    page_id={lastOpened}
                    doc_id={doc_id}
                    size={pages.size}
                    selected={this.state.selected}
                    clearSelected={this.clearSelected}
                />
                {this.table()}
            </Container>
        );
    }
}

export default connect(mapState, mapDispatch)(List);
